import { fontSizes, fonts, lineHeights, fontWeights } from '../theme';
import { pxToRem } from '../utils';
const titlepieceSizes = {
    small: fontSizes[8],
    medium: fontSizes[9],
    large: fontSizes[10],
};
const headlineSizes = {
    xxxsmall: fontSizes[3],
    xxsmall: fontSizes[4],
    xsmall: fontSizes[5],
    small: fontSizes[6],
    medium: fontSizes[7],
    large: fontSizes[8],
    xlarge: fontSizes[9],
};
const bodySizes = {
    small: fontSizes[2],
    medium: fontSizes[3],
};
const textSansSizes = {
    xxsmall: fontSizes[0],
    xsmall: fontSizes[1],
    small: fontSizes[2],
    medium: fontSizes[3],
    large: fontSizes[4],
    xlarge: fontSizes[5],
    xxlarge: fontSizes[6],
    xxxlarge: fontSizes[7],
};
const fontSizeMapping = {
    titlepiece: titlepieceSizes,
    headline: headlineSizes,
    body: bodySizes,
    textSans: textSansSizes,
};
const remFontSizes = fontSizes.map((fontSize) => pxToRem(fontSize));
const remTitlepieceSizes = {
    small: remFontSizes[8],
    medium: remFontSizes[9],
    large: remFontSizes[10],
};
const remHeadlineSizes = {
    xxxsmall: remFontSizes[3],
    xxsmall: remFontSizes[4],
    xsmall: remFontSizes[5],
    small: remFontSizes[6],
    medium: remFontSizes[7],
    large: remFontSizes[8],
    xlarge: remFontSizes[9],
};
const remBodySizes = {
    small: remFontSizes[2],
    medium: remFontSizes[3],
};
const remTextSansSizes = {
    xxsmall: remFontSizes[0],
    xsmall: remFontSizes[1],
    small: remFontSizes[2],
    medium: remFontSizes[3],
    large: remFontSizes[4],
    xlarge: remFontSizes[5],
    xxlarge: remFontSizes[6],
    xxxlarge: remFontSizes[7],
};
const remFontSizeMapping = {
    titlepiece: remTitlepieceSizes,
    headline: remHeadlineSizes,
    body: remBodySizes,
    textSans: remTextSansSizes,
};
const fontMapping = {
    titlepiece: fonts.titlepiece,
    headline: fonts.headlineSerif,
    body: fonts.bodySerif,
    textSans: fonts.bodySans,
};
const lineHeightMapping = {
    tight: lineHeights[0],
    regular: lineHeights[1],
    loose: lineHeights[2],
};
const fontWeightMapping = {
    light: fontWeights[0],
    regular: fontWeights[1],
    medium: fontWeights[2],
    bold: fontWeights[3],
};
const availableFonts = {
    titlepiece: {
        bold: {
            hasItalic: false,
        },
    },
    headline: {
        light: {
            hasItalic: true,
        },
        medium: {
            hasItalic: true,
        },
        bold: {
            hasItalic: false,
        },
    },
    body: {
        regular: {
            hasItalic: true,
        },
        bold: {
            hasItalic: true,
        },
    },
    textSans: {
        regular: {
            hasItalic: true,
        },
        bold: {
            hasItalic: false,
        },
    },
};
Object.freeze(titlepieceSizes);
Object.freeze(headlineSizes);
Object.freeze(bodySizes);
Object.freeze(textSansSizes);
Object.freeze(remTitlepieceSizes);
Object.freeze(remHeadlineSizes);
Object.freeze(remBodySizes);
Object.freeze(remTextSansSizes);
Object.freeze(fontMapping);
Object.freeze(fontSizeMapping);
Object.freeze(fontWeightMapping);
Object.freeze(lineHeightMapping);
Object.freeze(availableFonts);
export { titlepieceSizes, headlineSizes, bodySizes, textSansSizes, remFontSizes, remTitlepieceSizes, remHeadlineSizes, remBodySizes, remTextSansSizes, remFontSizeMapping, fontMapping, fontSizeMapping, lineHeightMapping, fontWeightMapping, availableFonts, };
//# sourceMappingURL=data.js.map
